<template>
  <div class="skill-tablet" :id="skill.id + '-skill-tablet'" @mouseenter="streamTextStart(skill.id)"
    @mouseleave="streamTextEnd(skill.id)">
    <div class="skill-tablet__content">
      <div class="stream-text-wrapper">
        <div class="stream-text">
          {{ skill.title }}
        </div>
        <div class="stream-text stream-text--delay">
          {{ skill.title }}
        </div>
      </div>
      <span :id="skill.id + '__content-title'">{{ skill.title }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["skill"],
  methods: {
    streamTextStart(skillId) {
      document.getElementById(skillId + "__content-title").style.opacity = 0;
    },
    streamTextEnd(skillId) {
      document.getElementById(skillId + "__content-title").style.opacity = 1;
    },
    randomFloat() {
      var randomInt = Math.floor(Math.random() * 1000);
      setTimeout(() => {
        document
          .getElementById(`${this.skill.id}-skill-tablet`)
          .classList.add("active");
      }, randomInt);
    },
  },
  mounted() {
    this.randomFloat();
  },
};
</script>

<style lang="scss" scoped>
.skill-tablet {
  display: block;
  overflow: hidden;

  .skill-tablet__content {
    transform: translateY(100px);
    transition-duration: 2s;
    transition-delay: 1s;
  }

  &.active {
    animation: float 4s ease-in-out infinite;

    .skill-tablet__content {
      transform: translateY(0);
    }
  }
}

.skill-tablet__content {
  white-space: nowrap;
  padding: 5px 30px;
  border: 2px solid #e6e6e6;
  border-radius: 500px;
  margin: 30px 10px;
  transition-duration: 0.2s;
  position: relative;
  will-change: transform;
  overflow: hidden;
  text-transform: uppercase;

  &:hover {
    .stream-text {
      opacity: 1;
    }
  }
}

.skill-tablet__content__title {
  position: relative;
  //   animation: leftToRight 4s infinite linear;
}

// .skill-table__content:focus,
// .skill-table__content:hover {
//   transform: scale(1.1);
//   outline: none;
// }
// .skill-table__content:focus:active,
// .skill-table__content:hover:active {
//   transform: scaleX(1.2);
//   transform: scaleY(0.9);
// }

/* Animations */
@keyframes float {

  from,
  to {
    transform: translate(0, 4.5%);
  }

  25% {
    transform: translate(-4.5%, 0);
  }

  50% {
    transform: translate(0, -4.5%);
  }

  75% {
    transform: translate(4.5%, 0);
  }
}

.stream-text {
  position: absolute;
  padding-left: 100%;
  white-space: nowrap;
  overflow: hidden;
  animation: stream 3s infinite linear;
  opacity: 0;
}

.stream-text--delay {
  animation-delay: 1.6s;
}

@keyframes stream {
  0% {
    transform: translateX(0%);
  }

  100% {
    transform: translateX(-130%);
  }
}
</style>
